import TableFilterSelect from '@aibees/elephant/components/table-filter-select/table-filter-select';
import { useAddSavedSearchTypeMetadata } from '@aibees/elephant/hooks/saved-search/use-add-saved-search-type-metadata';
import { ElephantPresetType } from '@aibees/elephant/types';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { CONFIG } from './config';
import type { SavedSearchTypesFilterProps as Props } from './types';

export const SavedSearchTypesFilter = memo(({ filters, setFilter }: Props) => {
  const options = useAddSavedSearchTypeMetadata(CONFIG, filters);

  return (
    <Stack flex={0.5}>
      <TableFilterSelect<ElephantPresetType>
        filters={filters}
        setFilter={setFilter}
        name="type"
        defaultValue={
          `${ElephantPresetType.COMPANY_SAVED_SEARCH},${ElephantPresetType.PEOPLE_SAVED_SEARCH}` as ElephantPresetType
        }
        options={options}
      />
    </Stack>
  );
});

SavedSearchTypesFilter.displayName = 'SavedSearchTypesFilter';
